import { css } from "@mui/material";
import { FC } from "react";
import { BaseProps } from "./text";
import GText from "./GText";

interface Props {
  axisX?: number;
  axisY?: number;
  delay?: number;
  text?: string;
  uppercase?: boolean;
}

const GTextRainbow: FC<Props & BaseProps> = (props) => {
  const listStyles = css`
    --axis-x: ${props.axisX}px;
    --axis-y: ${props.axisY}rem;
    --delay: ${props.delay};
    counter-reset: rainbow;
    position: relative;
    display: block;
    list-style: none;
    padding: 0;
    margin: 0;
    z-index: 1;
    font-size: inherit;

    & > li {
      counter-increment: rainbow;
      font-size: inherit;
      text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
        1px 1px 0 #000, 4px 4px 0 rgba(0, 0, 0, 0.2);
      animation: rainbow 1.5s ease-in-out infinite;
      font-weight: bold;

      &:not(:first-child) {
        position: absolute;
        top: 0;
      }
    }

    @keyframes rainbow {
      0%,
      100% {
        transform: translatey(var(--axis-y));
      }
      50% {
        transform: translatey(calc(var(--axis-y) * -1));
      }
    }
  `;

  const colors = [
    props.color ?? "#fff",
    "#D49C3D",
    "#D14B3D",
    "#CF52EB",
    "#44A3F7",
    "#5ACB3C",
    "#DEBF40",
  ];

  return (
    <GText {...props}>
      <ul css={listStyles}>
        {colors.map((c, idx) => (
          <li
            css={{
              animationDelay: `calc(${idx + 1} / ${
                props.delay
              } * 1s) !important`,
              left: `calc(${props.axisX}px * ${idx + 1})`,
              zIndex: -10 * (idx + 1),
              color: c,
              textTransform: props.uppercase ? "uppercase" : "initial",
            }}
            key={idx}
          >
            {props.text}
          </li>
        ))}
      </ul>
    </GText>
  );
};

GTextRainbow.defaultProps = {
  axisX: 1,
  axisY: 1,
  delay: 10,
  fontSize: 46,
  text: "Grooody",
  uppercase: true,
};

export default GTextRainbow;

// We need to add the below in framer
/*
addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    axisX: {
        title: "Axis X",
        type: ControlType.Number,
        defaultValue: 1,
    },
    axisY: {
        title: "Axis Y",
        type: ControlType.Number,
        defaultValue: 1,
    },
    delay: {
        title: "Delay",
        type: ControlType.Number,
        defaultValue: 10,
    },
    uppercase: {
        title: "Uppercase",
        type: ControlType.Boolean,
        defaultValue: true,
    },
})
*/
